export default "A look at how I modded an old game myself!";